export const TABLE_COLUMNS = [
  {
    Header: "Наименование услуги",
    accessor: "name",
  },
  {
    Header: "Номер кода",
    accessor: "codeNumber",
  },
  {
    Header: "Номер кода у агрегатора",
    accessor: "serviceEripCode",
  },
  {
    Header: "Стоимость",
    accessor: "sum",
  },
  {
    Header: "Тип услуги",
    accessor: "paidProcTypeName",
  },
];
